import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { legendItemStyle, legendStyle } from "./style";
import { mapDataCloudfrontURL } from "../map/MapConstants";

export const ProtezioneCivileLegend = ({ customLegendStyle = legendStyle, hazardName, day }) => {
  const { t } = useTranslation();
  const [fileInfo, setFileInfo] = useState({});

  const imageStoreUrl = `${mapDataCloudfrontURL}protezionecivile-bollettino/latest_file_info.json`;

  const timestamp = new Date().getTime();
  const cacheBustedUrl = `${imageStoreUrl}?t=${timestamp}`;

  useEffect(() => {
    const fetchFileInfo = async () => {
      try {
        const response = await fetch(cacheBustedUrl);
        const receivedFileInfo = await response.json();
        setFileInfo(receivedFileInfo);
      } catch (error) {
        console.error("Error fetching file info", error);
      }
    };

    fetchFileInfo();
  }, [cacheBustedUrl]);

  const showDate = fileInfo[day + "Date"];

  return (
    <div style={customLegendStyle}>
      <div>
        <b>{`Protezione Civile  ${t(`riskAssessment.${hazardName}`)} ${showDate}`}</b>
      </div>
      <div>
        <span style={legendItemStyle("green")}></span>
        {t("levels.noHazard")}
      </div>
      <div>
        <span style={legendItemStyle("yellow")}></span>
        {t("levels.low")}
      </div>
      <div>
        <span style={legendItemStyle("orange")}></span>
        {t("levels.moderate")}
      </div>

      <div>
        <span style={legendItemStyle("red")}></span>
        {t("levels.high")}
      </div>

      <div>
        <span
          style={{
            marginTop: 10,
            fontSize: "xx-small",
            display: "block",
            float: "left",
            width: "200px",
            lineHeight: 1,
          }}
        >
          Computed by Pr Civile at {fileInfo.evaluatedAt} {fileInfo.timeUTC}
          UTC <br></br> Downloaded by Cystellar at {fileInfo.timeDownloadUTC} UTC
        </span>
      </div>
    </div>
  );
};
